import { Navigate, useLocation } from "react-router-dom";
import SurveiPublik from "@/pages/SurveiPublik";
import { alamatSurvei } from "@/lib/survei";

// Rute sisa (path="*"). React Router 7 tidak mendukung awalan + parameter dalam SATU segmen
// ("/survei-peserta-didik-:kode"), jadi alamat survei per periode ditangkap di sini & diurai regex
// (alamatSurvei: /survei-peserta-didik-<kode> = Kedokteran, /survei-keperawatan-nakes-<kode> = Kepnakes). Alamat lain
// tetap dialihkan ke /dashboard persis seperti rute sisa sebelumnya.
export default function RuteSisa() {
    const { pathname } = useLocation();
    const alamat = alamatSurvei(pathname);
    return alamat
        ? <SurveiPublik key={`${alamat.kelompok}-${alamat.kode}`} kode={alamat.kode} kelompok={alamat.kelompok} />
        : <Navigate to="/dashboard" replace />;
}
